/**
 * Created by spepa on 24.12.2024
 */

const MSPwa = function () {
    Platform.call(this, connector.MSPWA);
};

MSPwa.prototype = Object.create(Platform.prototype);
MSPwa.prototype.constructor = MSPwa;

MSPwa.prototype.getLocalStoragePrefix = function () {
    return "_mspwa";
};
